if (!customElements.get('tooltip-info')) {
  customElements.define(
    'tooltip-info',
    class TooltipInfo extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.tooltip__trigger');
        this.content = this.querySelector('.tooltip__content');

        if (!this.trigger || !this.content) return;

        this.onDocumentClick = this.onDocumentClick.bind(this);

        this.trigger.addEventListener('click', this.toggle.bind(this));
        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') this.close();
        });
        this.addEventListener('focusout', this.onFocusOut.bind(this));
      }

      get isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      toggle(event) {
        event.preventDefault();
        this.isOpen ? this.close() : this.open();
      }

      open() {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.content.removeAttribute('hidden');
        document.addEventListener('click', this.onDocumentClick);
      }

      close() {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('hidden', '');
        document.removeEventListener('click', this.onDocumentClick);
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this.close();
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }
    }
  );
}
